<template>
    <v-container>
        <v-row justify="start" >
            <v-col cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
                <v-card>
                    <v-card-title>
                        <v-col xl="3" lg="4" md="5" sm="6" xs="6"><h1>Account Management</h1></v-col>
                        <v-col>
                            <v-btn color="primary" @click="add(false)">CREATE</v-btn>
                        </v-col>
                        <v-spacer/>
                    </v-card-title>
                    <v-card-title>
                        <!-- 搜尋欄位 -->
                        <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        ></v-text-field>
                    </v-card-title>
                    <!-- 帳號列表 -->
                    <v-data-table :headers="headers" :items="table_data" :search="search" class="elevation-1">
                        <template v-slot:item.index="{ item }">
                            {{table_data.findIndex(items => { return items.id == item.id})+1}}
                        </template>
                        <template v-slot:item.role="{item}">
                            <!-- 權限 -->
                            <span>{{ transDict[item.role]}}</span>
                        </template>
                        <template v-slot:item.last_login="{item}">
                            <!-- 讓時間顯示常規化 -->
                            <span v-if="item.last_login != null">{{ item.last_login | moment}}</span>
                            <span v-if="item.last_login == '' || item.last_login == null"> - </span>
                        </template>
                        <template v-slot:item.login_list="{item}">
                            <a class="mt-5">
                                <span style="text-decoration:underline;" @click="toLogin(item)">login list</span>                             
                            </a>
                        </template>
                        <template v-slot:item.query_list="{item}">                            
                            <a class="mt-5">
                                <span style="text-decoration:underline;" @click="toParam(item)">query list</span>                            
                            </a>                                
                        </template>
                        
                        <template v-slot:item.set="{item}">
                            <v-btn class="ml-3 mt-3" color="primary" @click="update(true, item)">EDIT</v-btn>
                            <v-btn class="ml-3 mt-3" color="error" @click="deleteCheck(item)">DELETE</v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            <!-- 新增/編輯欄位 -->

            <!-- <v-col cols="12" xl="3" lg="3" md="3" sm="12" xs="12" v-if="open==true"> -->
            <v-dialog v-model="open" width="500px" persistent>
                <v-card style="overflow: hidden;">
                    <v-card-title>
                        <span>{{ titleName }} </span>
                        <v-spacer/>
                        <v-icon style="align: right" @click="open=false;">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="mt-4 pa-6">
                       
                        <v-text-field v-model="sendData.account" label="Account:" outlined></v-text-field>
                        <v-select v-model="sendData.status" :items="status_list" label="Status:" outlined></v-select>
                        <v-text-field v-model="sendData.email" label="E-mail:" outlined></v-text-field>
                        <v-text-field v-model="sendData.company" label="Company:" outlined></v-text-field>                        
                        <v-select v-model="sendData.role" :items="roles_list" item-text="text" item-value="value" label="Role:" outlined></v-select>
                        <v-text-field 
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" 
                            v-model="sendData.password"
                            :type="show1 ? 'text' : 'password'"
                            @click:append="show1 = !show1"
                            label="New password:" 
                            outlined
                        >
                        </v-text-field>
                        <v-text-field 
                            label="Check password:" 
                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" 
                            v-model="sendData.passwordCheck"
                            :type="show2 ? 'text' : 'password'"
                            @click:append="show2 = !show2"
                            outlined>
                        </v-text-field>
                        <span v-if="edit_status==false">*These fields should be filled</span>
                    </v-card-text>
                    <v-card-actions class="pl-6 pr-6" justify="center">
                        <v-row justify="center">
                            <v-btn color="success" @click=" submit()" block>Submit</v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- </v-col> -->

            <v-dialog v-model="delete_dialog" max-width="500px" persistent>
                <v-card style="overflow: hidden;">
                    <v-card-title class="headline grey lighten-2">Delete {{delete_account}}?
                        <v-spacer/>
                        <v-icon @click="delete_dialog=false;">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-actions>        
                        <v-col>
                            <v-btn style="align: right" @click="delete_dialog = false;" block>取消</v-btn>
                        </v-col>   
                        <v-col>
                            <v-btn style="align: right" color="error" @click="del_account();" block>確定</v-btn>       
                        </v-col>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>
<script>
import axios from 'axios'
import bus from '../nav/bus'
import moment from 'moment'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    filters: {
        moment: function (date) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    data(){
        return {
            // 帳號表
            headers: [
                {text: 'No.', align: 'start', value: 'index', width: 60, class: "pa-5" },
                {text: 'Account', align: 'start', value: 'account', width: 150},
                {text: 'Email', align: 'start', value: 'email', width: 200},
                {text: 'Company', align: 'start', value: 'company', width: 150},
                {text: 'Role', align: 'start', value: 'role', width: 150},
                {text: 'Status', align: 'start', value: 'status', width: 100},
                {text: 'Last login', align: 'start', value: 'last_login', width: 210},
                {text: 'Login list', align: 'start', value: 'login_list', width: 150},
                {text: 'Query list', align: 'start', value: 'query_list', width: 150},
                {text: 'Action', align: 'center', value: 'set', width: 250, sortable: false},
            ],
            table_data: [],

            // 新增/編輯帳號
            sendData:{
                account: "",
                status: "active",
                email: "",
                company: "",
                role: "",
                password: "",
                passwordCheck: ""
            },
            // 權限轉換
            transDict: {
                "user": "External",
                "sales": "3DBU Internal"
            },

            createDialog: false,
            open: false,
            edit_status: false,
            titleName: 'Create Account',
            // 狀態
            status_list: ['active', 'inactive'],
            // 權限
            roles_list: [{text: '3DBU Internal', value: 'sales'}, {text: 'External', value: 'user'}],
            // 查詢
            search: '',
            // 密碼遮蔽
            show1: false,
            show2: false,
            // 刪除
            delete_dialog: false,
            delete_account: '',
            delete_index: null,
        }
    },
    created(){
        this.getAccount()
        let check_search = this.$route.query.params
        if(check_search){
            this.search = check_search
        }
    },
    methods:{        
        initData(){
            this.sendData = {
                account: "",
                status: "active",
                email: "",
                company: "",
                role: "",
                password: "",
                passwordCheck: ""
            }
        },
        getAccount(){
            axios.get(host_url+'account/get_account/')
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data   
                }                
            })
            .catch(error => {
                alert('Get accounts error')
            })
        },
        add(status){
            this.initData()
            this.open = true
            this.edit_status = status
            this.titleName = 'Create Account'        
        },
        update(status, item){
            this.open = true
            this.edit_status = status
            this.titleName = 'Edit Account'
            this.sendData = JSON.parse(JSON.stringify(item))            
        },
        deleteCheck(item){
            this.delete_dialog = true
            this.delete_account = item.account
            this.delete_index = this.table_data.findIndex(items => items.account == item.account)
        },
        del_account(){
            let account_id = this.table_data[this.delete_index].id

            axios.post(host_url+'account/delete_account/', {"account_id": account_id})
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data
                    bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                }
            })
            .catch(error => {
                console.log(error)
                bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
            })
            this.delete_dialog = false;
        },
        submit(){          
            if(this.edit_status == false){
                // 確認 account 不為空白
                if(this.sendData.account == ''){ alert('Account can not be empty'); return }
                // 確認信箱格式
                if(this.checkEmail(this.sendData.email) == false){ alert('The email format is invalid'); return }
                // 確認廠商 不為空白
                if(this.sendData.company == ''){ alert('Company can not be empty'); return }
                // 確認密碼格式
                if(this.checkPassword(this.sendData.password) == false){ alert('Password must have at least 8 characters'); return }
                if(this.checkPassword(this.sendData.passwordCheck) == false){ alert('Password Check must be the same with Password'); return}
                // 送 account data 到後端Server 
                axios.post(host_url+'account/create_account/', this.sendData)
                .then(response => {
                    let tmp = response.data
                    if(tmp.status == true){
                        this.table_data = tmp.data
                        bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                        this.open =false
                        
                    }
                    else{
                        bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                    }
                })
                .catch(error => {
                    console.log(error)
                    bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                })
            }
            else{
                // 送 account data 到後端Server 
                axios.post(host_url+'account/update_account/', this.sendData)
                .then(response => {
                    let tmp = response.data
                    if(tmp.status == true){
                        this.table_data = tmp.data
                        bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                        this.open =false
                    }
                    else{
                        bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                    }
                })
                .catch(error => {
                    bus.$emit('alert', {msg: tmp.msg, title: "Hint",　check: "Got it"})
                })
                // bus.$emit('alert', {msg: '修改帳號成功！', title: "提示",　check: "我知道了"})
            }
        },
        // 前往LoginOverview
        toLogin(item){
            this.$router.push({path: '/login_overview', query: { params: item.account}})
        },
        // 前往ParamOverview
        toParam(item){
            this.$router.push({path: '/params_overview', query: { params: item.company }})
        },
        // 確認信箱格式
        checkEmail(val){
            const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (regexp.test(val)){ return true; }
            else { return false; }
        },
        // 確認密碼格式
        checkPassword(val){
            const regexp = /^([0-9A-Za-z]+)/;
            if(val == ''){ return false}
            if(val.length < 8){ return false}
            if(!regexp.test(val)){ return false}
            if(val != this.sendData.password){ return false}
        },
    }
}
</script>
